<script>import { getContext } from 'svelte';
import { twMerge } from 'tailwind-merge';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
const forwardEvents = forwardEventsBuilder(get_current_component());
export let column;
$: columnWidth = 100 / columns.length;
const columns = getContext('table-columns');
const defaultClass = 'table-col first:pl-4 last:pl-3 last:pr-4 last:sm:pr-6 border-t truncate border-border py-2.5 pr-3 text-sm sm:pl-6 font-semibold md:font-normal text-secondary-content box-border stwui-table-body-row-cell';
const rightClass = 'text-right pl-3 pr-4 sm:pr-6 last:text-right';
const leftClass = 'text-left';
const noPlacementClass = 'last:text-right';
$: finalClass = twMerge(defaultClass, columns[column].class ? columns[column].class : false, columns[column].placement === 'right'
    ? rightClass
    : columns[column].placement === 'left'
        ? leftClass
        : noPlacementClass, $$props.class);
</script>

<td
	class={finalClass}
	style="{$$props.style ? $$props.style : ''}{columns[column].class
		? ''
		: ` width:${columnWidth}%`}"
	use:useActions={use}
	use:forwardEvents
	{...exclude($$props, ['use', 'class', 'style'])}
>
	<span class="block md:inline w-full static left-0 right-0 truncate">
		<slot />
	</span>
</td>
